(function () {
  'use strict';

  document.querySelectorAll('[data-testimonials-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-testimonials-track]');
    var prevBtn = carousel.querySelector('[data-testimonials-prev]');
    var nextBtn = carousel.querySelector('[data-testimonials-next]');

    if (!track) return;

    function getScrollAmount() {
      var firstCard = track.querySelector('.testimonials__card');
      if (!firstCard) return 300;
      var gap = parseFloat(window.getComputedStyle(track).gap) || 20;
      return firstCard.offsetWidth + gap;
    }

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      var scrollLeft = Math.round(track.scrollLeft);
      var maxScroll = track.scrollWidth - track.clientWidth;
      prevBtn.disabled = scrollLeft <= 1;
      nextBtn.disabled = scrollLeft >= maxScroll - 1;
    }

    function scrollPrev() {
      track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    }

    function scrollNext() {
      track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', scrollPrev);
    if (nextBtn) nextBtn.addEventListener('click', scrollNext);

    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);

    updateArrows();

    carousel.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); scrollPrev(); }
      if (e.key === 'ArrowRight') { e.preventDefault(); scrollNext(); }
    });
  });
})();
